import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'core-js/stable'

import 'view-design/dist/styles/iview.css';
import './assets/css-init.scss';
import iview from 'view-design';
Vue.use(iview);

import api from "./api/api"
Vue.use(api);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
